import './profile.css';
import profileImage from '../../assets/img/jpg/user.jpg';
import { Header } from "../../components/header/Header";
import { useAuth } from '../../context/AuthContext';
import { useState } from 'react';
import { ProfileForm } from '../../components/ProfileForm/ProfileForm';
import { PasswordChangeForm } from '../../components/PasswordChangeForm/PasswordChangeForm';
import { useLang } from '../../context/LangContext';

export function Profile() {
    const {user} = useAuth();
    const {lang} = useLang();

    //STATES
    const [menuOption, setMenuOption] = useState(0);

    return (
        <>
            <Header />
            <div className='profile_body'>
                <div className='container'>
                    <div className='heading'>
                        <div className='profile_image'>
                            <img src={profileImage} alt='' />
                        </div>
                        <div className='info'>
                            <h2>
                                {user && user.name}
                            </h2>
                            <span>
                                { lang === "en" ? "Modify your profile data" : "Modifica los datos relacionados con tu perfil"} 
                            </span>
                        </div>
                    </div>
                    <div className='body'>
                        <div className='menu'>
                            <div className={menuOption === 0 ? 'item active' : 'item'} onClick={() => setMenuOption(0)}>
                                <i className="fa-regular fa-user"></i>
                                { lang === "en" ? "Profile" : "Perfil"}
                            </div>
                            <div className={menuOption === 1 ? 'item active' : 'item'} onClick={() => setMenuOption(1)}>
                                <i className="fa-solid fa-lock"></i>
                                { lang === "en" ? "Change password" : "Cambiar contraseña"}
                            </div>
                        </div>
                        { menuOption === 0 && <ProfileForm /> }
                        { menuOption === 1 && <PasswordChangeForm /> }
                    </div>
                </div>
            </div>
        </>
    );
}